import { ConfigProvider, Input, Table, TableProps } from 'antd';
import enUS from 'antd/lib/locale/en_US';

interface GenericListProps<T> extends TableProps<T> {
  onSearch?: (value: string) => void;
}

export function GenericList<T extends object>({
  className,
  onSearch,
  ...props
}: GenericListProps<T>) {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        components: {
          Table: {
            headerBg: '#1a1a1a',
            headerColor: '#ffffff',
            headerSortActiveBg: '#2a2a2a',
            bodySortBg: '#181818',
            headerSortHoverBg: '#2a2a2a'
          },
          Pagination: {
            itemActiveBg: '#F74902',
            itemBg: '#222',
            itemInputBg: '#222',
            itemLinkBg: '#222'
          },
          Select: {
            selectorBg: '#27272a',
            optionSelectedBg: '#3f3f46',
            colorBgContainer: '#27272a',
            colorBgElevated: '#27272a',
            colorText: '#ffffff',
            colorTextPlaceholder: '#a1a1aa',
            colorBorder: '#3f3f46',
            controlOutline: 'transparent',
            borderRadius: 0,
            borderRadiusLG: 0,
            borderRadiusSM: 0
          }
        }
      }}
    >
      <div
        className={`w-full ${className} overflow-hidden border border-b-0 border-zinc-700`}
      >
        <div className='bg-zinc-800 px-4 py-4'>
          <div className='md:w-md w-full'>
            <Input.Search
              placeholder='Search'
              size='large'
              onSearch={onSearch}
              className='!font-orator [&_input::placeholder]:!font-orator'
            />
          </div>
        </div>
        <div className='border-t border-zinc-700 overflow-x-auto border-b-4 border-b-[#F74902]'>
          <Table<T>
            {...props}
            rowKey='id'
            locale={{
              emptyText: 'No data',
              triggerDesc: 'Click to sort descending',
              triggerAsc: 'Click to sort ascending',
              cancelSort: 'Click to cancel sorting'
            }}
            pagination={{
              ...props.pagination,
              showTotal: (total, range) =>
                <span className="font-orator text-white">{`${range[0]}-${range[1]} of ${total} items`}</span>
            }}
            className='[&_tbody_tr]:cursor-pointer [&_.ant-table-thead>tr>th]:!bg-zinc-900 [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:!font-orator [&_th]:!border-zinc-700 [&_td]:!border-zinc-700 [&_.ant-table-tbody>tr>td]:!bg-zinc-800 [&_.ant-table-tbody>tr>td]:!text-white [&_.ant-table-tbody>tr>td]:!font-orator [&_.ant-table-tbody>tr:hover>td]:!bg-zinc-700 [&_.ant-pagination]:!text-white [&_.ant-pagination]:!font-orator [&_.ant-pagination-total-text]:!text-white [&_.ant-pagination-item-link]:!bg-zinc-800 [&_.ant-pagination-item-link]:!border-zinc-700 [&_.ant-pagination-item-link]:!text-white [&_.ant-pagination-item-link]:!font-orator [&_.ant-pagination-item-link]:!rounded-none [&_.ant-pagination-item-link:hover]:!bg-zinc-800 [&_.ant-pagination-item-link:hover]:!border-zinc-700 [&_.ant-pagination-item-link:hover]:!text-white [&_.ant-pagination-item]:!bg-zinc-800 [&_.ant-pagination-item]:!border-zinc-700 [&_.ant-pagination-item]:!text-white [&_.ant-pagination-item]:!font-orator [&_.ant-pagination-item]:!rounded-none [&_.ant-pagination-item:hover]:!bg-zinc-800 [&_.ant-pagination-item:hover]:!border-zinc-700 [&_.ant-pagination-item:hover]:!text-white [&_.ant-pagination-item.ant-pagination-item-active]:!bg-zinc-800 [&_.ant-pagination-item.ant-pagination-item-active]:!border-zinc-700 [&_.ant-pagination-item.ant-pagination-item-active]:!text-white [&_.ant-pagination-item.ant-pagination-item-active:hover]:!bg-zinc-800 [&_.ant-pagination-item.ant-pagination-item-active:hover]:!text-white [&_.ant-pagination-item>a]:!text-white [&_.ant-pagination-item>a:hover]:!text-white [&_.ant-pagination-options]:!font-orator [&_.ant-pagination-options_.ant-select]:!font-orator [&_.ant-pagination-options_.ant-select-selector]:!bg-zinc-800 [&_.ant-pagination-options_.ant-select-selector]:!border-zinc-700 [&_.ant-pagination-options_.ant-select-selector]:!text-white [&_.ant-pagination-options_.ant-select-selector]:!font-orator [&_.ant-pagination-options_.ant-select-selector]:!rounded-none [&_.ant-pagination-options_.ant-select-selector]:!px-3 [&_.ant-pagination-options_.ant-select-selection-item]:!text-white [&_.ant-pagination-options_.ant-select-selection-item]:!font-orator [&_.ant-pagination-options_.ant-select-arrow]:!text-white [&_.ant-table-column-title]:!uppercase [&_.ant-table-thead>tr>th]:!uppercase [&_.ant-empty-description]:!text-white [&_.ant-empty-description]:!font-orator [&_.ant-empty-description]:!uppercase [&_.ant-table-cell]:!font-orator [&_.ant-table-cell]:!uppercase [&_.ant-table-column-sorter]:!text-white [&_.ant-table-column-sorter-up]:!text-white [&_.ant-table-column-sorter-down]:!text-white [&_.ant-table-column-sorter-up.active]:!text-white [&_.ant-table-column-sorter-down.active]:!text-white'
          />
        </div>
      </div>
    </ConfigProvider>
  );
}
